import React from 'react';
import { Upload, Search } from 'lucide-react';

interface EmptyStateProps {
  type: 'no-data' | 'no-results';
  searchTerm?: string;
  activeFilterCount?: number;
  onLoadSampleData?: () => void;
  onClearAllFilters?: () => void;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  type,
  searchTerm,
  activeFilterCount = 0,
  onLoadSampleData,
  onClearAllFilters
}) => {
  if (type === 'no-data') {
    return (
      <div className="bg-white rounded-2xl shadow-xl p-12 text-center">
        <div className="text-gray-400 mb-4">
          <Upload size={64} className="mx-auto" />
        </div>
        <h3 className="text-xl font-semibold text-gray-700 mb-2">Nenhum dado carregado</h3>
        <p className="text-gray-600 mb-6">
          Carregue um arquivo JSON ou use os dados de exemplo para começar
        </p>
        <button
          onClick={onLoadSampleData}
          className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors duration-200 shadow-md hover:shadow-lg"
        >
          Carregar Dados de Exemplo
        </button>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-2xl shadow-xl p-12 text-center">
      <div className="text-gray-400 mb-2">
        <Search size={48} className="mx-auto" />
      </div>
      <p className="text-gray-600">
        {searchTerm 
          ? `Nenhum resultado encontrado para "${searchTerm}"`
          : 'Nenhum resultado encontrado com os filtros aplicados'
        }
      </p>
      {activeFilterCount > 0 && (
        <button
          onClick={onClearAllFilters}
          className="mt-3 px-4 py-2 text-blue-600 hover:text-blue-800 underline transition-colors duration-150"
        >
          Limpar filtros
        </button>
      )}
    </div>
  );
};

export default EmptyState;